Vendd.Scripts.load(function () {
    'use strict';

    var $wrappers = $('.x-cart-searchbox');

    $wrappers.each(function (i, wrapper) {
        var $wrapper = $(wrapper);

        var $list = $('.x-product-suggestive-results-list', $wrapper);
        if ($wrapper.length < 1 || $list.length < 1)
            return; 

        var resultsPerPage = ($wrapper.data('page-size') || 12), pdPageNum = 1, isProductSelected = false,
            isLookupCompleted = false, maxResults = resultsPerPage,
            list = $list.get(0),
            $searchInput = $('.js-keyword', $wrapper), $qtyInput = $('.js-quantity', $wrapper),
            $increaseQtyInput = $('.js-incr-quantity', $wrapper), $decreaseQtyInput = $('.js-decr-quantity', $wrapper),
            $submitButton = $('.js-add-to-cart', $wrapper), minLength = $wrapper.data('min-search-length'),
            lazy = $list.data("lazy-load-init"), model = null,
            topResult = ($wrapper.data('top-results') || 100),
            isElastic = ($wrapper.data("is-elastic") || "false").toLowerCase() == "true",
            HasInfiniteScroll = ($wrapper.data("has-infinite-scroll") || "false").toLowerCase() == "true",
            infiniteScrollIsLoading = false;

        var lazyLoadPrices = $wrapper.data('lazyload-prices');
        if (typeof lazyLoadPrices === 'string') {
            lazyLoadPrices = lazyLoadPrices.trim().toLowerCase() === 'true';
        }

        wrapper.loading = function loading(loading) {
            isLookupCompleted = !loading;
            if (loading) {
                $wrapper.addClass('x-loading').addClass('x-disabled');
            } else {
                $wrapper.removeClass('x-loading').removeClass('x-disabled');
            }
            infiniteScrollIsLoading = false;
        };

        wrapper.enableInput = function enableInput(enable, $input) {
            if (enable) {
                $input.removeAttr('disabled').prop('disabled', false);
            } else {
                $input.attr('disabled', 'disabled').prop('disabled', true);
            }
        };

        wrapper.enableInputs = function enableInputs(enable) {
            wrapper.enableInput(false, $decreaseQtyInput);
            wrapper.enableInput(enable, $increaseQtyInput);
            wrapper.enableInput(enable, $qtyInput);
            wrapper.enableInput(enable, $submitButton);
        };

        list.update = function update() {
            wrapper.loading(true);

            var html = Vendd.Handlebars.parse('suggestiveResultProductList', model);
            var $html = $(html);
            var $newProducts = $('.product-results', $html);
            var $products = $('.product-results', $list).last();
            if ($products.length > 0)
                $newProducts.insertAfter($products);
            else
                $html.appendTo($list);
            if (!model.MoreProducts) {
                $('.js-more-results', $list).hide();
            }

            wrapper.loading(false);
        };

        list.clear = function clear() {
            $list.html('');
        };

        list.show = function show(show) {
            if (show) {
                $list.addClass('js-visible');
            } else {
                $list.removeClass('js-visible');
            }
        };

        wrapper.checkSearchTerm = function (searchTerm) {
            return /[a-zα-ωάέήίόύώϊϋΐΰςа-я0-9]{0,}/i.test(searchTerm);
        };

        wrapper.setSelectedProduct = function setSelectedProduct(data) {
            var productId = (data) ? data.productId : '',
                variantId = (data) ? data.variantId : '',
                path = (data) ? data.path : '',
                availabilityActionId = (data) ? data.availabilityActionId : '',
                name = (data) ? data.name : '',
                stock = (data) ? data.stock : 0,
                minQuantity = (data) ? data.minQuantity : 0,
                maxQuantity = (data) ? data.maxQuantity : 0,
                quanta = (data) ? data.quanta : 0,
                color = (data) ? data.color : '',
                size = (data) ? data.size : '',
                list = (data) ? data.list : '';

            $searchInput.attr('data-productid', productId);
            $searchInput.attr('data-variantid', variantId);
            $searchInput.attr('data-path', path);
            $searchInput.attr('data-availability-action-id', availabilityActionId);
            $searchInput.attr('data-min-quantity', minQuantity);
            $searchInput.attr('data-max-quantity', maxQuantity);
            $searchInput.attr('data-quanta', quanta);
            $searchInput.attr('data-color', color);
            $searchInput.attr('data-size', size);
            $searchInput.attr('data-list', list);
            if (name != '') $searchInput.val(name);
            $qtyInput.attr('data-stock', stock);

            var quantity = stock > minQuantity ? minQuantity : 1;
            if (quantity > 0 && quanta > 0 && quantity % quanta !== 0) {
                quantity = quanta;
            }

            $qtyInput.val(numberToString(quantity));

            wrapper.enableInputs(stock > 0);
            isProductSelected = (data) ? true : false;
        };

        $list.on('click', '.js-list-item', function () {
            var $item = $(this);
            var data = {
                productId: $item.data('productid').toString(),
                variantId: $item.data('variantid').toString(),
                path: $item.data('path').toString(),
                availabilityActionId: $item.data('availability-action-id').toString(),
                name: $item.data('name'),
                stock: parseInt($item.data('stock')),
                minQuantity: parseFloat(($item.data('min-quantity') ? stringToNumber($item.data('min-quantity')) : null) || 1),
                maxQuantity: parseFloat(($item.data('max-quantity') ? stringToNumber($item.data('max-quantity')) : null) || 0),
                quanta: parseFloat(($item.data('quanta') ? stringToNumber($item.data('quanta')) : null) || 1),
                color: $item.data('color') ? $item.data('color') : "",
                size: $item.data('size') ? $item.data('size') : "",
                list: $item.data('list') ? $item.data('list') : ""
            };

            wrapper.setSelectedProduct(data);
            list.show(false);
        });

        $list.on('click', '.js-more-results', function () {
            var searchTerm = $searchInput.val();
            if ($searchInput.val().length >= minLength && !isProductSelected) {
                //maxResults = maxResults + resultsPerPage;
                //maxResults = Math.min(maxResults, topResult);
                pdPageNum++;
                if (isElastic) {
                    Vendd.MessageBus.publishAsync(wrapper, new Vendd.Search.Messages.GetProductSuggestiveElasticResults(searchTerm, pdPageNum, maxResults));
                }
                else {
                    Vendd.MessageBus.publishAsync(wrapper, new Vendd.Search.Messages.GetProductSuggestiveResults(searchTerm, 10000, pdPageNum, maxResults));
                }
            } else {
                list.show(false);
            };
        });

        $wrapper.on('click', '.js-incr-quantity', function () {
            var $this = $(this);
            if ($this.hasClass('x-disabled') || $this.is(':disabled'))
                return;

            var stock = parseInt($qtyInput.data('stock'));

            var quanta = parseFloat(($searchInput.data('quanta') ? stringToNumber($searchInput.data('quanta')) : null) || 1);
            var minQuantity = parseFloat(($searchInput.data('min-quantity') ? stringToNumber($searchInput.data('min-quantity')) : null) || 1);
            var maxQuantity = parseFloat(($searchInput.data('max-quantity') ? stringToNumber($searchInput.data('max-quantity')) : null) || stock);

            var tempQuantity = parseFloat(stringToNumber($qtyInput.val()));

            if (tempQuantity >= 0) {
                tempQuantity = tempQuantity + quanta;
                if (tempQuantity <= maxQuantity) {
                    wrapper.enableInput(tempQuantity !== maxQuantity, $increaseQtyInput);
                    $qtyInput.val(numberToString(tempQuantity));
                } else
                    wrapper.enableInput(false, $increaseQtyInput);

                if (tempQuantity > minQuantity) wrapper.enableInput(true, $decreaseQtyInput);
            }

            var enableSubmitButton = (parseFloat(stringToNumber($qtyInput.val())) > 0 && isProductSelected);
            wrapper.enableInput(enableSubmitButton, $submitButton);
        });

        $wrapper.on('click', '.js-decr-quantity', function () {
            var $this = $(this);
            if ($this.hasClass('x-disabled') || $this.is(':disabled'))
                return;

            var stock = parseInt($qtyInput.data('stock'));
            var tempQuantity = parseFloat(stringToNumber($qtyInput.val()));
            var quanta = parseFloat(($searchInput.data('quanta') ? stringToNumber($searchInput.data('quanta')) : null) || 1);
            var minQuantity = parseFloat(($searchInput.data('min-quantity') ? stringToNumber($searchInput.data('min-quantity')) : null) || 1);
            var maxQuantity = parseFloat(($searchInput.data('max-quantity') ? stringToNumber($searchInput.data('max-quantity')) : null) || stock);

            if (tempQuantity !== minQuantity && tempQuantity > 0) {
                tempQuantity = tempQuantity - quanta;
                $qtyInput.val(numberToString(tempQuantity));
                wrapper.enableInput(true, $increaseQtyInput);
            }

            if (tempQuantity <= minQuantity)
                wrapper.enableInput(false, $decreaseQtyInput);

            var enableSubmitButton = (parseFloat(stringToNumber($qtyInput.val())) > 0 && isProductSelected);
            wrapper.enableInput(enableSubmitButton, $submitButton);
        });

        if (HasInfiniteScroll) {
            $list.on('scroll', function (e) {
                var $viewItem = $('.js-more-results', $list);
                if (!$viewItem.is(':visible') && infiniteScrollIsLoading) return;
                var scrollTop = $list.scrollTop();
                var innerHeight = $list.innerHeight();
                var scrollHeight = list.scrollHeight;
                var innerHeight_v = $viewItem.innerHeight();
                var infiniteScrollPadding = 20;
                console.log('innerHeight_v , ' + innerHeight_v + ' | outerHeight_v' + $viewItem.outerHeight(true));
                var isVisible = (scrollHeight - (scrollTop + innerHeight + infiniteScrollPadding)) < innerHeight_v;
                if (isVisible && !infiniteScrollIsLoading) {
                    infiniteScrollIsLoading = true;
                    $viewItem.trigger('click');
                }
            });
        }

        $wrapper.on('keyup', '.js-quantity', function () {
            var $this = $(this);
            if ($this.hasClass('x-disabled') || $this.is(':disabled'))
                return;

            var stock = parseInt($qtyInput.data('stock'));

            var tempQuantity = parseFloat(stringToNumber($qtyInput.val()));
            var quanta = parseFloat(($searchInput.data('quanta') ? stringToNumber($searchInput.data('quanta')) : null) || 1);
            var minQuantity = parseFloat(($searchInput.data('min-quantity') ? stringToNumber($searchInput.data('min-quantity')) : null) || 1);
            var maxQuantity = parseFloat(($searchInput.data('max-quantity') ? stringToNumber($searchInput.data('max-quantity')) : null) || stock);

            var selectedQuantity = tempQuantity;

            if (quanta > 1 && tempQuantity % quanta !== 0) {
                tempQuantity = tempQuantity - (tempQuantity % quanta);
            }

            if (tempQuantity < maxQuantity && tempQuantity > minQuantity) {
                selectedQuantity = tempQuantity;
            } else if (tempQuantity >= maxQuantity) {
                selectedQuantity = quanta > 1 && maxQuantity % quanta !== 0 ? maxQuantity - (maxQuantity % quanta) : maxQuantity;
            } else if (tempQuantity <= minQuantity) {
                selectedQuantity = quanta > 1 && minQuantity % quanta !== 0 ? minQuantity - (minQuantity % quanta) : minQuantity;
            }

            $qtyInput.val(numberToString(selectedQuantity));

            var enableIncreaseQtyInput = (tempQuantity < maxQuantity),
                enableDecreaseQtyInput = (tempQuantity > minQuantity),
                enableSubmitButton = (selectedQuantity > minQuantity && selectedQuantity > maxQuantity && isProductSelected);

            wrapper.enableInput(enableIncreaseQtyInput, $increaseQtyInput);
            wrapper.enableInput(enableDecreaseQtyInput, $decreaseQtyInput);
            wrapper.enableInput(enableSubmitButton, $submitButton);
        });

        $wrapper.on('click', '.js-add-to-cart', function (e) {
            if ($searchInput.val().length >= minLength && isLookupCompleted && isProductSelected) {
                e.preventDefault();
                e.stopPropagation();

                var $this = $(this);
                if ($this.hasClass('x-disabled') || $this.is(':disabled')) return;

                var id = $searchInput.attr('data-productid');
                var skuId = $searchInput.attr('data-variantid');
                var path = $searchInput.attr('data-path');
                var qty = parseFloat(stringToNumber($qtyInput.val())) || 1;
                var extraAttributes = [];
                var bundleItems = [];
                var recipeItems = [];
                var comboItems = [];
                var itemInfo = {
                    minQuantity: parseFloat(($searchInput.data('min-quantity') ? stringToNumber($searchInput.data('min-quantity')) : null) || 0),
                    maxQuantity: parseFloat(($searchInput.data('max-quantity') ? stringToNumber($searchInput.data('max-quantity')) : null) || 0),
                    quanta: parseFloat(($searchInput.data('quanta') ? stringToNumber($searchInput.data('quanta')) : null) || 0),
                };

                //enhanced info
                var color = $searchInput.data('color');
                var size = $searchInput.data('size');
                var list = $searchInput.data('list');


                var enhancedInfo = { color: color, size: size, list: list };
                //enhanced info

                Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.Add(id, skuId, path, qty, extraAttributes, bundleItems, recipeItems, comboItems, itemInfo, enhancedInfo));
            };
        });

        $wrapper.on('keyup', '.js-keyword', $.debounce(850, function () {
            var searchTerm = $searchInput.val();
            if (isProductSelected) {
                wrapper.setSelectedProduct(null);
            }
            list.clear();
            pdPageNum = 1;
            if (searchTerm.length >= minLength && wrapper.checkSearchTerm(searchTerm)) {
                wrapper.loading(true);
                //maxResults = resultsPerPage;
                //maxResults = Math.min(maxResults, topResult);
                if (isElastic) {
                    Vendd.MessageBus.publishAsync(wrapper, new Vendd.Search.Messages.GetProductSuggestiveElasticResults(searchTerm, pdPageNum, maxResults));
                }
                else {
                    Vendd.MessageBus.publishAsync(wrapper, new Vendd.Search.Messages.GetProductSuggestiveResults(searchTerm, maxResults, pdPageNum, maxResults));
                }
            } else {
                list.show(false);
            }
        }));

        $wrapper.on('click', '.js-keyword', function (e) {
            e.preventDefault();
            e.stopPropagation();

            $searchInput.select();
        });

        $wrapper.on('focus', '.js-keyword', function () {
            var show = ($searchInput.val().length >= minLength && isLookupCompleted && !isProductSelected);
            list.show(show);
        });

        Vendd.MessageBus.subscribe(Vendd.Search.Messages.GetProductSuggestiveResultsFailed, wrapper, function (envelope) {
            list.show(false);
            wrapper.loading(false);
        });

        Vendd.MessageBus.subscribe(Vendd.Search.Messages.GetProductSuggestiveResultsSuccess, wrapper, function (envelope) {
            model = envelope.message.data.model;
            if (model.sender != wrapper) {
                list.show(false);
                wrapper.loading(false);
                return;
            }
            model.MoreProducts = (model.ProductsCount || 0) > (maxResults * pdPageNum);
            if (pdPageNum > 1) model.PageNumber = pdPageNum;
            list.update();
            list.show(true);
        });

        Vendd.MessageBus.subscribe(Vendd.Search.Messages.GetProductSuggestiveResultsElasticFailed, wrapper, function (envelope) {
            list.show(false);
            wrapper.loading(false);
        });

        Vendd.MessageBus.subscribe(Vendd.Search.Messages.GetProductSuggestiveResultsElasticSuccess, wrapper, function (envelope) {
            model = envelope.message.data.model;
            model.IsElastic = isElastic;

            //check if current user has custom prices
            var currentUser = Vendd.User && Vendd.User.GetClientModel();
            var customPrices = currentUser && currentUser.HasCustomPrices;
            model.HasLazyLoadPrices = lazyLoadPrices || customPrices;

            model.HasInfiniteScroll = HasInfiniteScroll;
            model.MoreProducts = ((((model || {}).hits || {}).total || {}).value || 0) > (maxResults * pdPageNum);
            if (pdPageNum > 1) model.PageNumber = pdPageNum;
            
            if (model.HasLazyLoadPrices && model.hits.hits.length > 0) {
                var items = _.pluck(_.pluck(model.hits.hits, '_source'), 'VariantId');
                var obj = {
                    itemIds: items,
                    fetchPrices: true,
                    fetchAvailabilities: false,
                    fetchStock: false
                };
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.ScrollList.Messages.GetClientProductListData(obj));

                Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetClientProductListDataSuccess, wrapper, function (envelope) {
                    var result = JSON && JSON.parse(envelope.message.data) || $.parseJSON(envelope.message.data);
                    var modelWithPrices = _.each(model.hits.hits, function (obj) {
                        var selectedProduct = _.find(result.Products, function (x) { return obj._source.VariantId === x.VariantId; });
                        if (selectedProduct) _.extend(obj._source, selectedProduct.Prices);
                    });
                    _.extend(model.hits.hits, modelWithPrices);

                    list.update();
                    list.show(true);
                    Vendd.MessageBus.unsubscribe(Vendd.ScrollList.Messages.GetClientProductListDataSuccess, wrapper);
                });
            } else {
                list.update();
                list.show(true);
            }
        });

        Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, wrapper, function (envelope) {
            if (!isProductSelected)
                return;

            wrapper.setSelectedProduct(null);
        });

        $(document).mouseup(function (e) {
            if (!$wrapper.is(e.target) && $wrapper.has(e.target).length === 0) {
                list.show(false);
            }
        });

    });
});